import React, { useEffect } from 'react';

import LandingTemplate from '../../bizLanding/landingTemplate';
import ExpenseApp from './ExpenseApp';
import { NavigationLinks } from './config';
import { logPageLoadEvents } from '../../logging/omnitureService';
import { PATHS } from 'AppConstants';

const loggedInHandler = () => {
	window.location = `${PATHS.DASHBOARD}`;
};

const ExpenseSeo = (props) => {
	const { isLoggedInUser, isMobile } = props;

	useEffect(() => {
		logPageLoadEvents('expenseonboardingpage:v1', {
			prop39: String(!!isLoggedInUser)
		});
	}, []);

	return (
		<LandingTemplate
			showChatBot
			isLoggedInUser={isLoggedInUser}
			loggedInHandler={loggedInHandler}
			headerActions={{ showSignup: true }}
			headerLinks={NavigationLinks}
			loginRedirectUrl={PATHS.DASHBOARD}
			{...props}>
			<ExpenseApp isMobile={isMobile} isLoggedInUser={isLoggedInUser} />
		</LandingTemplate>
	);
};

export default ExpenseSeo;
